
    <!--
 * 竖版-首充领奖
 * @LastEditTime: Sat Sep 14 2024 18:08:17 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_113F49"  :class="[`normal`,`u_c_113F49`]" ><div id="u_c_EZY950"  :class="[`${ compData.title ? 'text' : '' }`,`normal `,`u_c_EZY950`]" ><div id="u_c_9ETL51"  v-html="compData.title" :class="[`normal`,`u_c_9ETL51`]" ></div></div><div id="u_c_4Y2C52"  v-html="compData.subTitle" :class="[`normal`,`u_c_4Y2C52`]" ></div><div id="u_c_HKT035"  :class="[`normal`,`u_c_HKT035`]" @click="u_c_HKT035_event_75MQ21($event)">{{`[${ langData.checkGiftBtn }]`}}</div><div id="u_c_94ZU53"  :style="`background-image:url(${ compData.giftIcon })`" :class="[`normal`,`u_c_94ZU53`]" @click="u_c_94ZU53_event_TMS123($event)"></div><a id="u_c_GVOB54" href="javascript:;" :style="`background-image:url(${ pageData['common-btn-bg'] })`" :class="[`${ pageData.firstPayState == 2 && pageData.firstPayType != 'sendCoupon' ? 'has' : 'btn-light' }`,`normal  `,`u_c_GVOB54`]" @click="u_c_GVOB54_event_NP9I65($event)"><div id="u_c_HGYQ55"  :class="[`normal page-common-btn`,`u_c_HGYQ55`]" ><div id="u_c_67AJ56"  v-show="pageData.firstPayState != 2" :class="[`normal `,`u_c_67AJ56`]" >{{`${ langData.getBtn }`}}</div><div id="u_c_2F1C58"  v-show="pageData.firstPayState == 2 && pageData.firstPayType != 'sendCoupon'" :class="[`normal `,`u_c_2F1C58`]" >{{`${ langData.hasBtn }`}}</div><div id="u_c_471C60"  v-show="pageData.firstPayState == 2 && pageData.firstPayType == 'sendCoupon'" :class="[`normal `,`u_c_471C60`]" >{{`${ langData.useBtn }`}}</div></div></a></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"subTitle":`活动期间，通过官网渠道成功储值任意金额即可领取xxxxxx`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172241579317865618.png`,"giftName":`首储礼包`,"title":`成神归来
每日赠礼`},"zh-TW":{"subTitle":`活動期間，通過【官網儲值頁面】任意管道成功儲值任意金額，即可領取元寶*288、點將令*10、兵種技錦囊*10、高級輜重箱*2，每個帳號只能領取一次；`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172241579317865618.png`,"giftName":`元寶*288
點將令*10
兵種技錦囊*10
高級輜重箱*2`,"title":`超值首儲贈好禮`}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['zh-TW']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {})
const checkIsLogin = inject("checkIsLogin", () => {})
const listData = inject("listData", {})
const showTips = inject("showTips", (txt, code) => {})
const showGetSucc = inject("showGetSucc", (type, pic, name) => {})
const giftInfo = inject("giftInfo", {})
const getCurLink = inject("getCurLink", (link) => {})

giftInfo.firstPayAward = [{
  name: compData.giftName
}]
const curPlatform = pagePlatform;
const canClick = ref(true)

const getFirstGift = async () => {

  let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'firstPayAward'), {
    params: JSON.stringify({
      language: curLang,
    }),
  })
  if (res.result == 1) {
    pageData.firstPayState = 2
    let curGiftName = pageData.firstPayType == 'sendSerial' ? res.data.send_value : compData.giftName
    showGetSucc(pageData.firstPayType, compData.giftIcon, curGiftName)
  } else {
    showTips(getLangTxt(res.code, getLangTxt("common")), res.code)
  }
  return res.result == 1
};
      // 查看奖励复制_1的click事件
      const u_c_HKT035_event_75MQ21= async (e)=>{
        try {pageData.seeGift = [{
  name: compData.giftName,
  pic: compData.giftIcon
}];
pageData.seeGiftPopupState = true;} catch (error) {console.log(error)}
      };
      // 首储道具礼包的click事件
      const u_c_94ZU53_event_TMS123= async (e)=>{
        try {let arr = []
arr.push({
  name: compData.giftName,
  pic: compData.giftIcon
})
pageData.seeGift = arr;
pageData.seeGiftPopupState = true;} catch (error) {console.log(error)}
      };
      // 领取按钮的click事件
      const u_c_GVOB54_event_NP9I65= async (e)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
if (+pageData.firstPayState > 1) {
  if (pageData.firstPayType == 'sendCoupon') {
    window.activityDataLayer.push({
      eventName: 'click_button',
      eventType: '前往使用优惠券',
      gameId: pageData.gameId,
      aid: pageData.pageId,
    });
    bridge.open(pageData.storeLink)
  }
  return;
}
if (!canClick.value) return;
canClick.value = false;
window.activityDataLayer.push({
  eventName: 'click_button',
  eventType: '领取首储奖励',
  gameId: pageData.gameId,
  aid: pageData.pageId,
});
await getFirstGift();
canClick.value = true;
} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_113F49.normal{
position:relative;
width:10.00rem;
height:13.05rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726307208534-84.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.default{
.u_c_EZY950.normal{
position:relative;
width:9.79rem;
height:2.55rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.68rem;
font-size:0.93rem;
color:#fedb2a;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EZY950.normal.text{
width:100%;
height:auto;

}
}.default{
.u_c_9ETL51.normal{
position:relative;

}
}.default{
.u_c_4Y2C52.normal{
position:relative;
margin-top:0.56rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.default{
.u_c_HKT035.normal{
position:relative;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.20rem;
cursor:pointer;

}
}.default{
.u_c_94ZU53.normal{
position:relative;
margin:auto;
margin-top:0.75rem;
background:no-repeat center;
background-size:contain;
width:5.17rem;
height:3.95rem;
cursor:pointer;

}
}.default{
.u_c_GVOB54.normal{
position:relative;
width:5.36rem;
height:2.77rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.13rem;
display:block;
overflow:hidden;

}

.u_c_GVOB54.normal.has{
filter:grayscale(1);

}
}.default{
.u_c_HGYQ55.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:0.87rem;

}
}.default{
.u_c_67AJ56.normal{
position:relative;

}
}.default{
.u_c_2F1C58.normal{
position:relative;

}
}.default{
.u_c_471C60.normal{
position:relative;

}
}.zh-TW{
.u_c_113F49.normal{
position:relative;
width:10.00rem;
height:13.05rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726307208534-84.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.zh-TW{
.u_c_EZY950.normal{
position:relative;
width:9.79rem;
height:2.55rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.68rem;
font-size:0.93rem;
color:#fedb2a;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EZY950.normal.text{
width:100%;
height:auto;

}
}.zh-TW{
.u_c_9ETL51.normal{
position:relative;

}
}.zh-TW{
.u_c_4Y2C52.normal{
position:relative;
margin-top:0.56rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.zh-TW{
.u_c_HKT035.normal{
position:relative;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
margin-top:0.20rem;
cursor:pointer;

}
}.zh-TW{
.u_c_94ZU53.normal{
position:relative;
margin:auto;
margin-top:0.75rem;
background:no-repeat center;
background-size:contain;
width:5.17rem;
height:3.95rem;
cursor:pointer;

}
}.zh-TW{
.u_c_GVOB54.normal{
position:relative;
width:5.36rem;
height:2.77rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.13rem;
display:block;
overflow:hidden;

}

.u_c_GVOB54.normal.has{
filter:grayscale(1);

}
}.zh-TW{
.u_c_HGYQ55.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:0.87rem;

}
}.zh-TW{
.u_c_67AJ56.normal{
position:relative;

}
}.zh-TW{
.u_c_2F1C58.normal{
position:relative;

}
}.zh-TW{
.u_c_471C60.normal{
position:relative;

}
}
</style>
